// import { CKEditor } from '@ckeditor/ckeditor5-react';
import React from 'react';
import ButtonContainer from '../sharedcomponents/buttoncontainer/buttonContainer';
import CustomDialog from '../sharedcomponents/dialog/dialog';
//import Editor from 'ckeditor5-custom-build/build/ckeditor';
import TinyMCEEditor from '../sharedcomponents/tinymceEditor/tinymce';
import APIURLConstants from '../config/config';
import ApiHelper from '../utility/ApiHelper';
import Helper from '../utility/helper';
import { generatePath, useHistory } from 'react-router-dom';
import RouteConstants from '../constants/routeConstants';
import { Typography } from '@mui/material';
import { useAgentState } from '../hookState/AgentState';


export default function ContactUs(props) {
    const history = useHistory();
    const agentState = useAgentState();
    const agentInfo = Helper.getStorage('agentInfo');

    const [contactBody, setContactBody] = React.useState('');
    const [loading, setLoading] = React.useState(false); 

    const handleClick = () => {
        if (contactBody === '') {
            props.setSnackBarProps({
                ...props.snackBarProps,
                openSnack: true,
                variant: 'error',
                message: 'Please Enter Description',
            });
            return;
        }
        const eventInfo = Helper.getStorage('eventInfo');
        const userInfo = Helper.getStorage('userInfo');
        let form = new FormData();
        form.append("userID", userInfo.userID);
        form.append("body", contactBody != '' ? encodeURIComponent(contactBody) : contactBody);
        form.append('modifyBy', agentState.visible.value
        ? agentInfo.userID
        : userInfo.userID,)
        setLoading(true)
        ApiHelper.post(APIURLConstants.CONTACT_US_EMAIL, form)
            .then((res) => {
                // console.log(res);
                if (res.data) {
                    setLoading(false)
                    props.setSnackBarProps({
                        ...props.snackBarProps,
                        openSnack: true,
                        variant: 'success',
                        message: 'Player Feedback Submitted, Please Check Email.',
                    });
                    props.handleClose() 
                    const path = (eventInfo && eventInfo.eventID && eventInfo.eventID !== null) ? generatePath(RouteConstants.EVENT_DETAIL, { 'eventID':  eventInfo.eventID}) : generatePath(RouteConstants.DASHBOARD);
                    history.push({
                        pathname: path,
                    });
                }
            })
            .catch((err) => {
                setLoading(false)
                console.log(err);
            })
    }
    const renderDialogContent = () => (
        <>
            <Typography variant='body1' sx={{ mb: 2 }}>
                If you have any questions, issues, or feedback, please enter your comments below and a member of NBA League Operations will reach out to you shortly.
            </Typography>
            <TinyMCEEditor
                value={contactBody}
                setValue={setContactBody}                
            />
            {/* <CKEditor
                editor={Editor}
                config={{
                    image: {
                        upload: ['jpeg', 'png', 'gif', 'bmp', 'webp', 'tiff']
                    },
                    removeButtons: 'Subscript,Superscript',
                    extraAllowedContent: '*{*};*(*);span{!color}'
                }}
                data={contactBody}
                onChange={(event, editor) => {
                    console.log(event);
                    setContactBody(editor.getData())
                }}
            /> */}
        </>
    );
    const renderDialogActions = () => (
        <ButtonContainer
            showLoading={true}
            loading={loading}
            handleClick={handleClick}
            handleCancel={props.handleClose}
            buttonText='Send'
        />
    );

    return (
        <>
            <CustomDialog
                title={props.title}
                handleClose={props.handleClose}
                open={props.open}
                fullWidth={true}
                maxWidth={'md'}
                renderContent={renderDialogContent}
                renderActions={renderDialogActions}
                disableEnforceFocus={true}
            />
        </>
    )

}
